import { render, staticRenderFns } from "./traTelegramChat.vue?vue&type=template&id=473ca290&scoped=true&"
import script from "./traTelegramChat.vue?vue&type=script&lang=js&"
export * from "./traTelegramChat.vue?vue&type=script&lang=js&"
import style0 from "./traTelegramChat.vue?vue&type=style&index=0&id=473ca290&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ca290",
  null
  
)

export default component.exports